/* eslint-disable no-unused-vars */
import { ExcludeSettingsForm, Loader, ErrorComponent } from 'components';
import * as S from './ExcludeSettings.styled';
import { campaignsManageAPI } from 'services/campaignsManage.service';

const footerBtns = [
  {
    type: 'submit',
    id: 'saveButton',
    buttonColor: 'Primary',
    btnText: 'Save Settings',
    isDisabled: true,
    isRedirect: false,
    redirectId: '',
  },
  {
    type: '',
    id: 'cancelButton',
    buttonColor: 'Secondary',
    btnText: 'Back to Manage Campaigns',
    isDisabled: false,
    isRedirect: true,
    redirectId: 'campaign',
  },
];

export const ExcludeSettings = () => {
  const { data, isLoading, isError } = campaignsManageAPI.useGetCampaignsAdvancedSettingsQuery();
  const [saveCampaignsAdvancedSettings, result] =
    campaignsManageAPI.useSaveCampaignsAdvancedSettingsMutation();

  const handleSaveCampaignsAdvancedSettings = (data) => {
    let dataToSave = data;
    if (data.excluded_publishers.length) {
      dataToSave = {
        ...data,
        excluded_publishers: data.excluded_publishers.map(({ pb_number }) => pb_number),
      };
    }
    saveCampaignsAdvancedSettings(dataToSave);
  };

  if (isError) {
    return <ErrorComponent />;
  }

  if (isLoading || !data) {
    return (
      <S.LoaderContainer>
        <Loader.Local delay={0} />
      </S.LoaderContainer>
    );
  }

  return (
    <ExcludeSettingsForm
      data={data}
      updateAction={handleSaveCampaignsAdvancedSettings}
      result={result}
      footerBtnsObj={footerBtns}
    />
  );
};
